export const AUTH0_USER_ROLES_KEY = 'http://binariks.com/roles';
export const AUTH0_USER_UNIT_ID_KEY = 'http://binariks.com/unitId';

export const ROW_ACTIONS = {
  EDIT: 'edit',
  ADD: 'add',
  DELETED: 'deleted',
  DELETE: 'delete',
};

export const MAX_FILE_SIZE = 7340032;

export const SURE_MODAL_TEXT = {
  CHANGES_TEXT:
    'The inputed data is not saved. Would you like to save changes on this page before living it?',
  DELETE_TEXT: (data: string) =>
    `Are you sure that you want to delete ${data}?`,
};

export const SURE_MODAL_BUTTONS = {
  DELETE: 'Delete',
  CANCEL: 'Cancel',
};
export const ALL_OPTION = 'All';
